/* ActionTypes */
import { FETCH_SHOW_BY_ID, FETCH_CONTINUE_WATCHING_BY_SHOW_ID } from './actionTypes';

/* Utils */
import { generateRequestActionCreator } from '../utils/generators/actionGenerators';

export const fetchShowById = ({ showId, sourceProvider }) => ({
  type: FETCH_SHOW_BY_ID,
  payload: {
    showId,
    sourceProvider,
  },
});

export const getContinueWatchingShow = generateRequestActionCreator((showId) => ({
  type: FETCH_CONTINUE_WATCHING_BY_SHOW_ID,
  payload: showId,
}));
